/**
 * Profile resource - /api/profile endpoints
 */
import { getLogger } from '@qwickapps/logging';
const log = getLogger('QwickForge.MiddlewareClient.ProfileResource');
export class ProfileResource {
    http;
    constructor(http) {
        this.http = http;
    }
    /**
     * Get current user's profile
     */
    async get() {
        log.debug('Getting profile');
        const profile = await this.http.get('/api/profile');
        log.debug('Profile retrieved', { userId: profile.userId });
        return profile;
    }
    /**
     * Update current user's profile
     */
    async update(data) {
        log.debug('Updating profile');
        const profile = await this.http.patch('/api/profile', data);
        log.debug('Profile updated', { userId: profile.userId });
        return profile;
    }
}
//# sourceMappingURL=ProfileResource.js.map